"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRaceById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Updates a race by given ID (if it exists).
 *
 * ### Updatable fields
 * - `name`
 * - `instructions`
 * - `objectives`
 * - `startDate`
 * - `endDate`
 * - `downloadLink`
 * - `downloadGrace`
 * - `uploadGrace`
 * - `icon`
 * - `isActive`
 * - `isDone`
 *
 * ## Usage
 * ```ts
 * const raceId: string = "5f5e555d5a578b6";
 * const race: Partial<Race> = {
 *	downloadLink: "http://http.cat/201.jpg",
 * };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updateRaceById({ raceId, race });
 * ```
 *
 * @param params.raceId - ID of the race to update.
 * @param params.race   - Fields to update in the chosen race.
 */
const updateRaceById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId, race } = params;
    const url = `${BASE_URL}/races/race/${raceId}`;
    const raceResponse = yield axios_1.default.put(url, race, { validateStatus: () => true });
    const { status, data } = raceResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updateRaceById = updateRaceById;
